import React, {useState} from 'react';
import * as R from 'ramda';
import liendirect from '../../../../assets/images/svg/049-family.svg';
import autres from '../../../../assets/images/svg/051-parents.svg';
import parsePhoneNumber from 'libphonenumber-js';
import {InviteUserRepresentative} from '../../../../actions/facilita-api';

export const ColapsedView = ({referent, toggleEditMode}) => {
    const [isSendingInvitation, setIsSendingInvitation] = useState(false);
    var countries = require("i18n-iso-countries");
    countries.registerLocale(require("i18n-iso-countries/langs/fr.json"));
    const gender = { male: 2, female: 1 };

    const representativeTypeEnum = ["", "Child", "Parent", "Sibling", "Spouse", "Other"]

    const representativeType = {direct: 'Family', other:'Other'};
    const representativeTypeFamily = {Child: 'Fils/Fille', Parent:'Parent', Sibling:'Frère/Soeur', Spouse:'Conjoint'};
    const parsedPhoneNumber = !R.isNil(referent.phoneNumber) && referent.phoneNumber !== "" ? parsePhoneNumber(referent.phoneNumber).formatInternational() : undefined;
    return (
        <div className={"card card-body pb-0 mb-4"}>
            <div className="flex-row align-items-center gx-2">
                <div className=""></div>
                <h2 className="h4 text-secondary text-uppercase font-weight-bolder my-auto">{referent.isMainRepresentative === true ? 'MANDATAIRE PRINCIPAL' : 'AUTRE MANDATAIRE'}</h2>

                {/* <button type="button" className={"btn text-muted p-0 ml-auto loading-btn btn-if align-items-center" + (isSendingInvitation ? " show" : "")} name="resend" onClick={(e) => {
                    e.preventDefault();
                    setIsSendingInvitation(true);
                    InviteUserRepresentative(referent.id)
                    .then(() => setIsSendingInvitation(false));
                }}>
                    <span className="aling-middle o-60">Renvoyer invitation</span>
                    <i className="eva eva-email-outline ml-2 h4 my-auto lh-1 aling-middle"></i>
                    <div className="loading loading-spinner spinner-border spinner-border-sm ml-2 mr-n1"></div>
                </button> */}
            </div>
            <hr className="my-3" />
            
            <div className="block mb-3">
                    <h4 className="h6 font-weight-bolder">{referent.gender === gender.male ? 'Monsieur' : 'Madame'}</h4>
                    <h3 className="h3 font-weight-bolder mb-4">{referent.lastName} {referent.firstName}</h3>
                <div className="card text-capitalize flex-row align-items-center mb-3">
                    <img className="img-fluid my-auto mb-2 h-5 w-5 py-1" src={representativeTypeEnum[referent.representativeType] === representativeType.other ? autres : liendirect} alt={representativeTypeEnum[referent.representativeType] === representativeType.other ? "autres" : "lien familial direct"} />
                    <h2 className="h6 font-weight-bolder ml-2 pl-1 mb-0 text-uppercase">{representativeTypeEnum[referent.representativeType] === representativeType.other ? 'Autres' : representativeTypeFamily[representativeTypeEnum[referent.representativeType]]}</h2>
                </div>
                {
                    !R.isNil(referent.birthDate) ?
                        <div className="flex-row align-items-start mb-3">
                            <i className="eva lh-copy eva-calendar-outline mr-2 o-50"></i>
                            <p className="h5 lh-copy my-auto">{new Date(referent.birthDate).toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' })}</p>
                        </div>
                    :
                        ''
                }
                
                <div className="flex-row align-items-start mb-3">
                    <i className="eva lh-copy eva-home-outline mr-2 o-50"></i>
                    <p className="h5 lh-copy my-auto">{referent.addresses[0].addressLine1} <br />{referent.addresses[0].postalCode} {referent.addresses[0].city}, {countries.getName(referent.addresses[0].country, "fr", {select: "official"})}</p>
                </div>
                {
                    R.isNil(referent.email) || referent.email === "" ? 
                        ''
                    :
                        <div className="flex-row align-items-start mb-3">
                            <i className="eva lh-copy eva-email-outline mr-2 o-50"></i>
                            <p className="h5 lh-copy my-auto">{referent.email}</p>
                        </div>
                }
                {
                    R.isNil(parsedPhoneNumber) ? 
                        ''
                    :
                        <div className="flex-row align-items-start mb-3">
                            <i className="eva lh-copy eva-phone-outline mr-2 o-50"></i>
                            <p className="h5 lh-copy my-auto">{parsedPhoneNumber}</p>
                        </div>
                }
                <button type="button" className="btn btn-block btn-alert-primary loading-btn" name="refPrincipal" onClick={(e) => {
                    e.preventDefault();
                    toggleEditMode(referent.id);
                }}>
                    Modifier
                    <div className="loading loading-spinner spinner-border spinner-border-sm ml-2 mr-n1"></div>
                </button>
            </div>
        </div>
    )
}